'use client';

import {
    ErrorBoundary,
    useIsExperimentFullSolution,
    useLoyaltyContext,
    useUserSession,
} from '@libs/common-next';
import { useEffect, useState } from 'react';
import { LoggedIn } from './LoggedIn';
import { SignIn } from './SignIn';

import './LegacyAccountDropdown.scss';

export default function LegacyAccountDropdown() {
    const { storageUserSession, ocapi, user, userData } = useUserSession();
    const { firstName, isRegistered } = storageUserSession ?? {};
    const [displayLoggedIn, setDisplayLoggedIn] = useState<boolean | undefined>(
        undefined
    );
    const { memberPoints } = useLoyaltyContext();
    const isExperimentFullSolution = useIsExperimentFullSolution();

    useEffect(() => {
        if (isExperimentFullSolution) {
            setDisplayLoggedIn(!!user);
        } // Verify that session is loaded and up to date
        else if (ocapi.data?.session?.customer?.first_name === firstName) {
            setDisplayLoggedIn(Boolean(isRegistered && firstName));
        } else if (!ocapi.data && firstName === undefined) {
            setDisplayLoggedIn(false);
        }
    }, [firstName, isRegistered, ocapi, user, isExperimentFullSolution]);

    return (
        <div className="legacy-account">
            {displayLoggedIn !== undefined && displayLoggedIn ? (
                // TODO: SonarQube: Extract this nested ternary operation into an independent statement. - The code quality issue must be addressed separately. Out of scope for CPC-2557.
                isExperimentFullSolution ? (
                    <LoggedIn
                        firstName={
                            isExperimentFullSolution
                                ? userData?.profile?.firstName
                                : user?.gn
                        }
                        loyaltyPoints={memberPoints?.availablePoints}
                    />
                ) : (
                    <LoggedIn {...storageUserSession} />
                )
            ) : (
                <ErrorBoundary>
                    <SignIn />
                </ErrorBoundary>
            )}
        </div>
    );
}
